<template>
    <div>
        <div class="formSubmit">
            <vForm
                class="clearfix"
                labelWidth="60"
                v-model="formData"
                ref="editform"
            >
                <div v-if="type === 'checkBill'">
                    <vAlert theme="info"
                        >将自动创建调账单并进入账单，请谨慎操作。</vAlert
                    >
                    <vCol span="20">
                        <vFormItem
                            label="调账类型"
                            class="width-100per"
                            labelWidth="120"
                        >
                            <span>调账返还</span>
                        </vFormItem>
                    </vCol>

                    <vCol span="20">
                        <vFormItem
                            label="调账金额(USD)"
                            class="width-100per"
                            prop="reimbursementAmount"
                            :rules="required"
                            labelWidth="120"
                            style="margin-bottom: 0px"
                        >
                            <vInputNumber
                                :min="0.001"
                                v-model="formData.actualAmount"
                            ></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="20" style="margin-top: 24px">
                        <vFormItem label="备注" prop="remark" labelWidth="120">
                            <vTextarea v-model="formData.remark"></vTextarea>
                        </vFormItem>
                    </vCol>
                </div>
                <div v-if="type === 'aduit'">
                    <vCol span="20">
                        <vFormItem
                            prop="radioType"
                            label="审核"
                            :rules="required"
                        >
                            <RadioGroup v-model="formData.opAction">
                                <Radio :label="4" style="font-size: 12px"
                                    >审核通过</Radio
                                >
                                <Radio :label="5" style="font-size: 12px"
                                    >审核拒回</Radio
                                >
                            </RadioGroup>
                        </vFormItem>
                    </vCol>
                    <vCol span="20">
                        <vFormItem label="caseId" prop="caseId" labelWidth="80">
                            <Input v-model="formData.caseId" />
                        </vFormItem>
                    </vCol>
                    <vCol span="20" v-if="formData.opAction == 4">
                        <vFormItem
                            label="复核时间"
                            prop="reviewAt"
                            labelWidth="80"
                        >
                            <vDatepicker
                                type="time"
                                v-model="formData.reviewAt"
                                format="yyyy-mm-dd"
                            ></vDatepicker>
                        </vFormItem>
                    </vCol>
                    <vCol span="20">
                        <vFormItem label="备注" prop="opData" labelWidth="80">
                            <vTextarea v-model="formData.opData"></vTextarea>
                        </vFormItem>
                    </vCol>
                    <vCol span="20">
                        <vFormItem label="附件上传" labelWidth="80">
                            <div class="upload">
                                <div
                                    class="upload-item"
                                    v-for="(item, index) in attachMetas.items"
                                    :key="item.key"
                                >
                                    <div class="filename">
                                        {{ item.attachTitle }}
                                    </div>
                                    <div>
                                        <Icon
                                            class="close"
                                            size="13"
                                            type="md-close"
                                            @click="clearUpload(index)"
                                        />
                                    </div>
                                </div>
                            </div>
                            <vButton theme="success" @click="importFile"
                                >选择文件</vButton
                            >
                        </vFormItem>
                    </vCol>
                </div>
                <vCol
                    span="20"
                    style="margin-top: 24px"
                    v-if="type === 'addRemark'"
                >
                    <vFormItem
                        label="备注"
                        :rules="required"
                        prop="remark"
                        labelWidth="120"
                    >
                        <vTextarea v-model="formData.remark"></vTextarea>
                    </vFormItem>
                </vCol>

                <vCol
                    span="20"
                    v-if="type === 'addRemark' || type === 'checkBill'"
                >
                    <vFormItem label="附件上传" labelWidth="120">
                        <div class="upload">
                            <div
                                class="upload-item"
                                v-for="(item, index) in attachMetas.items"
                                :key="item.key"
                            >
                                <div class="filename">
                                    {{ item.attachTitle }}
                                </div>
                                <div>
                                    <Icon
                                        class="close"
                                        size="13"
                                        type="md-close"
                                        @click="clearUpload(index)"
                                    />
                                </div>
                            </div>
                        </div>
                        <vButton theme="success" @click="importFile"
                            >选择文件</vButton
                        >
                    </vFormItem>
                </vCol>
                <div class="pull-right">
                    <vButton
                        style="margin: 10px 5px"
                        theme="primary"
                        @click="submit"
                        >确定</vButton
                    >
                    <vButton style="margin: 10px 5px" @click="cancel"
                        >取消</vButton
                    >
                </div>
            </vForm>
            <vModal
                class="hidefooter customerupload"
                v-model="operate.show"
                :title="operate.title"
                v-bind="operate"
            >
                <compMutiUpload
                    v-bind="getFileProps"
                    @on-success="aaasuccess"
                    @on-cancel="cancelUpload"
                />
                <footer slot="footer" v-show="false"></footer>
            </vModal>
        </div>
        <vLoading loading size="large" transfer v-if="loading"></vLoading>
    </div>
</template>

<script>
import {
    HttpDelFile,
    HttplogOrderAction,
    HttpReimbursementGetById,
    HttpCheckBill,
} from "@/service/reimbursement";
export default {
    components: {
        compMutiUpload: () => import("@components/templates/mutiUpload"),
    },
    props: ["type", "headId"],
    created() {
        this.getDetail();
    },
    data() {
        return {
            loading: false,
            formData: {
                remark: "",
                opAttachMeta: "",
                actualAmount: "",
                opAction: 4,
                caseId: "",
            },

            attachMetas: {
                items: [],
                opAt: "",
                organizationId: "",
            },
            required: [
                {
                    required: true,
                    message: "该信息不能为空,请填写",
                },
            ],
            operate: {
                width: 460,
                show: false,
                title: "附件上传",
                data: {},
            },
        };
    },
    computed: {
        getFileProps() {
            return {
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                data: {
                    srcLabel: this.formData.id,
                    model: "logistics",
                    type: "other",
                },
            };
        },
    },
    methods: {
        getDetail() {
            HttpReimbursementGetById({
                id: this.headId,
            }).then(
                (res) => {
                    this.disUse = true;
                    this.formData.actualAmount =
                        res.data.reimbursementEntity.reimbursementAmount;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        importFile() {
            this.operate.show = true;
        },
        clearUpload(index) {
            HttpDelFile({
                contextId: global.SYSID,
                id: this.attachMetas.items[index].attachId,
            }).then(
                (res) => {
                    this.attachMetas.items.splice(index, 1);
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        aaasuccess(res) {
            res.items.forEach((item) => {
                this.attachMetas.items.push(item);
            });
            this.attachMetas.opAt = res.opAt;
            this.attachMetas.organizationId = res.organizationId;

            this.cancelUpload();
        },
        cancelUpload() {
            this.operate.show = false;
        },
        async submit() {
            const valid = await this.$refs.editform.validate();
            if (!valid) return;
            this.loading = true;
            this.formData.opAttachMeta = JSON.stringify(this.attachMetas);
            if (this.type === "addRemark") {
                HttplogOrderAction({
                    contextId: global.SYSID,
                    headId: this.headId,
                    opAction: 6,
                    opData: this.formData.remark,
                    opAttachMeta: this.formData.opAttachMeta,
                }).then(
                    (res) => {
                        this.loading = false;
                        this.$VMessage.success("备注成功");
                        this.success();
                    },
                    (err) => {
                        this.loading = false;
                        this.$VMessage.error(err.message);
                    }
                );
            } else if (this.type === "checkBill") {
                var remark =
                    " 备注:" +
                    this.formData.remark +
                    "  调账金额:" +
                    this.formData.actualAmount;
                HttpCheckBill({
                    contextId: global.SYSID,
                    headId: this.headId,
                    opAction: 10,
                    opData: remark,
                    actualAmount: this.formData.actualAmount,
                    opAttachMeta: this.formData.opAttachMeta,
                }).then(
                    (res) => {
                        this.loading = false;
                        this.$VMessage.success("操作完成");
                        this.success();
                    },
                    (err) => {
                        this.loading = false;
                        this.$VMessage.error(err.message);
                    }
                );
            } else if (this.type === "aduit") {
                HttplogOrderAction({
                    contextId: global.SYSID,
                    headId: this.headId,
                    opAction: this.formData.opAction,
                    opData: this.formData.opData,
                    reviewAt: this.formData.reviewAt,
                    opAttachMeta: this.formData.opAttachMeta,
                    caseId: this.formData.caseId,
                }).then(
                    (res) => {
                        this.loading = false;
                        this.$VMessage.success("审核成功");
                        this.success();
                    },
                    (err) => {
                        this.loading = false;
                        this.$VMessage.error(err.message);
                    }
                );
            }
        },
        success() {
            this.$emit("on-close");
            this.$emit("on-update");
            this.$emit("refreshPage");
        },
        cancel() {
            this.$emit("on-close");
        },
    },
};
</script>

<style lang="scss" scoped>
.upload-item {
    display: flex;
    color: #3399ff;

    .filename {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .close {
        margin-left: 5px;
        &:hover {
            color: red;
            cursor: pointer;
        }
    }
}
</style>
